// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.terms-email {\n  color: #7b7b7b;\n  text-decoration: underline;\n  word-break: break-all;\n}\n.terms-list li {\n\tmargin-bottom: 0rem;\n}\n.nl2br {\n  white-space: pre-line;\n}\n", ""]);
// Exports
module.exports = exports;
